import React from 'react';

interface StatRowProps {
  label: string;
  homeValue: { value: number; total: number };
  awayValue: { value: number; total: number };
}

const StatRow: React.FC<StatRowProps> = ({ label, homeValue, awayValue }) => {
  const formatValue = (value: number, total: number, label: string) => {
    // For "Matches Played" and "Points", only show the raw number
    if (label === "Matches Played" || label === "Points") {
      return `${value}`;
    }
    // For all other stats, show percentage
    return `${value} (${((value / total) * 100).toFixed(1)}%)`;
  };

  return (
    <tr className="border-b">
      <td className="py-2 text-right font-medium text-blue-600">
        {formatValue(homeValue.value, homeValue.total, label)}
      </td>
      <td className="py-2 text-center font-semibold text-gray-600">{label}</td>
      <td className="py-2 text-left font-medium text-red-600">
        {formatValue(awayValue.value, awayValue.total, label)}
      </td>
    </tr>
  );
};

export default StatRow;